import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginRoutes } from './login.routing';
import { NotificationsComponent } from '../../notifications/notifications.component';
import { UpgradeComponent } from '../../upgrade/upgrade.component';

import { AuthenticationService } from '../../services/auth/auth.service';

import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatTooltipModule,
} from '@angular/material';
@NgModule({
  imports: [
    RouterModule.forChild(LoginRoutes)
  ],
  declarations: [
  ],
  providers: [
    AuthenticationService
  ]
})

export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.module.ts